export default {
  "ED_ar-QA": {
    "cookiesPolicyLink": "https://www.edreams.qa/cookie-policy/"
  },
  "ED_ca": {
    "cookiesPolicyLink": "https://www.edreams.es/ca/avis-galetes/"
  },
  "ED_de-CH": {
    "cookiesPolicyLink": "http://www.edreams.ch/cookies/"
  },
  "ED_de-DE": {
    "cookiesPolicyLink": "https://www.edreams.de/cookies/"
  },
  "ED_el-GR": {
    "cookiesPolicyLink": "https://www.edreams.gr/cookie-policy/"
  },
  "ED_en-AU": {
    "cookiesPolicyLink": "https://www.edreams.com.au/cookie-policy/"
  },
  "ED_en-CA": {
    "cookiesPolicyLink": "https://ca.edreams.com/cookie-policy/"
  },
  "ED_en-CZ": {
    "cookiesPolicyLink": "https://www.edreams.cz/cookie-policy/"
  },
  "ED_en-GB": {
    "cookiesPolicyLink": "https://www.edreams.co.uk/cookie-policy/"
  },
  "ED_en-HK": {
    "cookiesPolicyLink": "https://www.edreams.hk/cookie-policy/"
  },
  "ED_en-HU": {
    "cookiesPolicyLink": "https://hu.edreams.com/cookie-policy/"
  },
  "ED_en-ID": {
    "cookiesPolicyLink": "https://id.edreams.com/cookie-policy/"
  },
  "ED_en-IN": {
    "cookiesPolicyLink": "https://www.edreams.in/cookie-policy/"
  },
  "ED_en-NZ": {
    "cookiesPolicyLink": "https://nz.edreams.com/cookie-policy/"
  },
  "ED_en-PH": {
    "cookiesPolicyLink": "https://www.edreams.ph/cookie-policy/"
  },
  "ED_en-QA": {
    "cookiesPolicyLink": "https://www.edreams.qa/en/merch/cookie-policy/"
  },
  "ED_en-SG": {
    "cookiesPolicyLink": "https://sg.edreams.com/cookie-policy/"
  },
  "ED_en-TH": {
    "cookiesPolicyLink": "https://th.edreams.com/cookie-policy/"
  },
  "ED_en-TW": {
    "cookiesPolicyLink": "https://www.edreams.tw/en/merch/cookie-policy/"
  },
  "ED_en-US": {
    "cookiesPolicyLink": "https://www.edreams.net/cookie-policy/"
  },
  "ED_en-ZA": {
    "cookiesPolicyLink": "https://za.edreams.com/cookie-policy/"
  },
  "ED_en": {
    "cookiesPolicyLink": "https://www.edreams.com/cookie-policy/"
  },
  "ED_es-AR": {
    "cookiesPolicyLink": "https://www.edreams.com.ar/politica-de-cookies/"
  },
  "ED_es-CL": {
    "cookiesPolicyLink": "https://cl.edreams.com/politica-de-cookies/"
  },
  "ED_es-CO": {
    "cookiesPolicyLink": "https://co.edreams.com/politica-de-cookies/"
  },
  "ED_es-ES": {
    "cookiesPolicyLink": "https://www.edreams.es/politica-de-cookies/"
  },
  "ED_es-MX": {
    "cookiesPolicyLink": "https://www.edreams.com.mx/politica-de-cookies/"
  },
  "ED_es-PE": {
    "cookiesPolicyLink": "https://www.edreams.pe/politica-de-cookies/"
  },
  "ED_es-US": {
    "cookiesPolicyLink": "https://www.edreams.net/es/politica-de-cookies/"
  },
  "ED_fr-CA": {
    "cookiesPolicyLink": "https://ca.edreams.com/fr/utilisation-cookies/"
  },
  "ED_fr-CH": {
    "cookiesPolicyLink": "https://www.edreams.ch/fr/utilisation-cookies/"
  },
  "ED_fr-FR": {
    "cookiesPolicyLink": "https://www.edreams.fr/utilisation-cookies/"
  },
  "ED_fr-MA": {
    "cookiesPolicyLink": "https://www.edreams.ma/utilisation-cookies/"
  },
  "ED_it-CH": {
    "cookiesPolicyLink": "https://www.edreams.ch/it/politica-cookies/"
  },
  "ED_it-IT": {
    "cookiesPolicyLink": "https://www.edreams.it/politica-cookies/"
  },
  "ED_ja-JP": {
    "cookiesPolicyLink": "https://www.edreams.jp/cookies/"
  },
  "ED_ko-KR": {
    "cookiesPolicyLink": "https://www.edreams.co.kr/ko/cookie-policy/"
  },
  "ED_nl-NL": {
    "cookiesPolicyLink": "http://nl.edreams.com/cookiebeleid/"
  },
  "ED_pt-PT": {
    "cookiesPolicyLink": "https://www.edreams.pt/politica-de-cookies/"
  },
  "ED_ro-RO": {
    "cookiesPolicyLink": "https://ro.edreams.com/politica-privind-modulele-cookie/"
  },
  "ED_tr-TR": {
    "cookiesPolicyLink": "https://www.edreams.com.tr/cookie-kullanim-politikasi/"
  },
  "ED_zh-CN": {
    "cookiesPolicyLink": "https://cn.edreams.com/cookies/"
  },
  "ED_zh-TW": {
    "cookiesPolicyLink": "https://www.edreams.tw/zh/cookie-policy/"
  },
  "GO_fr-FR": {
    "cookiesPolicyLink": "https://www.govoyages.com/politique-de-cookies/"
  },
  "OP_ar-AE": {
    "cookiesPolicyLink": "https://ae.opodo.com/ar/cookie-policy/"
  },
  "OP_ca": {
    "cookiesPolicyLink": "https://www.opodo.es/ca/avis-galetes/"
  },
  "OP_da-DK": {
    "cookiesPolicyLink": "https://www.opodo.dk/cookie-notice/"
  },
  "OP_de-AT": {
    "cookiesPolicyLink": "https://www.opodo.at/cookies/"
  },
  "OP_de-CH": {
    "cookiesPolicyLink": "https://www.opodo.ch/cookies/"
  },
  "OP_de-DE": {
    "cookiesPolicyLink": "https://www.opodo.de/cookies/"
  },
  "OP_en-AE": {
    "cookiesPolicyLink": "https://ae.opodo.com/cookie-policy/"
  },
  "OP_en-AU": {
    "cookiesPolicyLink": "https://www.opodo.com.au/cookie-policy/"
  },
  "OP_en-GB": {
    "cookiesPolicyLink": "https://www.opodo.co.uk/cookies/"
  },
  "OP_en": {
    "cookiesPolicyLink": "https://www.opodo.com/cookie-policy/"
  },
  "OP_es-ES": {
    "cookiesPolicyLink": "https://www.opodo.es/politica-de-cookies/"
  },
  "OP_fi-FI": {
    "cookiesPolicyLink": "https://www.opodo.fi/cookies/"
  },
  "OP_fr-CH": {
    "cookiesPolicyLink": "https://www.opodo.ch/fr/utilisation-cookies/"
  },
  "OP_fr-FR": {
    "cookiesPolicyLink": "https://www.opodo.fr/cookies/"
  },
  "OP_it-CH": {
    "cookiesPolicyLink": "https://www.opodo.ch/it/politica-cookies/"
  },
  "OP_it-IT": {
    "cookiesPolicyLink": "https://www.opodo.it/utilizzo-cookies/"
  },
  "OP_nl-NL": {
    "cookiesPolicyLink": "https://www.opodo.nl/cookiebeleid/"
  },
  "OP_no-NO": {
    "cookiesPolicyLink": "https://www.opodo.no/cookies/"
  },
  "OP_pl-PL": {
    "cookiesPolicyLink": "https://www.opodo.pl/cookies/"
  },
  "OP_pt-PT": {
    "cookiesPolicyLink": "https://www.opodo.pt/politica-de-cookies/"
  },
  "OP_sv-SE": {
    "cookiesPolicyLink": "https://www.opodo.se/cookies/"
  },
  "TR_da-DK": {
    "cookiesPolicyLink": "https://www.travellink.dk/cookie-notice/"
  },
  "TR_de-DE": {
    "cookiesPolicyLink": "https://www.travellink.de/cookies/"
  },
  "TR_en": {
    "cookiesPolicyLink": "https://www.travellink.com/cookies/"
  },
  "TR_fi-FI": {
    "cookiesPolicyLink": "https://www.travellink.fi/cookies/"
  },
  "TR_is-IS": {
    "cookiesPolicyLink": "https://www.travellink.is/cookies"
  },
  "TR_no-NO": {
    "cookiesPolicyLink": "https://www.travellink.no/cookies/"
  },
  "TR_sv-SE": {
    "cookiesPolicyLink": "https://www.travellink.se/cookies/"
  }
};
